<template>
    <div class="row">
        <div class="col-12">
            <LabelTableListing
                :triggerSearch="triggerSearch"
                :triggerSearchName="triggerSearchName"
                :triggerTab="triggerTab"
            />
        </div>
    </div>
</template>

<script>
import i18n from "@/i18n";
import 'vue2-datepicker/index.css';
import LabelTableListing from '@/views/pages/productLabelNew/labelTableNew.vue';

export default {
    page: {
        title: i18n.t("label.listingX", [i18n.t('module.productLabel')]),
    },
    props: {
        triggerSearch: {
            type: String,
            default: null,
        },
        triggerSearchName: {
            type: String,
            default: null,
        },
        triggerTab: {
            type: String,
            default: null,
        }
    },
    components: { LabelTableListing },
};
</script>
